import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import TradesDistributionSkelton from "../../skeleton/TradesDistributionSkeleton";
import { TradesDistributionInterface } from "../../../../../types/dashboard.types";
import { Box, Grid, Text, useColorMode } from "theme-ui";
import LegendPill from "../ResidentialVsCommercial/LegendPill";
import { useSelector } from "react-redux";

const TradesDistribution = ({ tradesDistribution, loading }: { tradesDistribution: TradesDistributionInterface, loading: boolean }) => {
    const { flag } = useSelector((state: any) => state.dashboardData);
    const chartRef = useRef(null);
    const [colorMode] = useColorMode();
    const bgGeographic = colorMode === 'light' ? "#ffffff" : "#2e354db8";
    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#252b36";
    const titleHeader = colorMode === 'light' ? "#453521" : "#f8f9fa";
    useEffect(() => {
        if (!chartRef.current || tradesDistribution === null || tradesDistribution === undefined) return;
        const chart = echarts.init(chartRef.current);

        const chartData = [
            { value: tradesDistribution["Mechanical (Standard)"] || 0, name: "Mechanical", color: "#16A34A" },
            { value: tradesDistribution["Electrical (Standard)"] || 0, name: "Electrical", color: "#CA8A04" },
            { value: tradesDistribution["Plumbing (Standard)"] || 0, name: "Plumbing", color: "#2563EB" },
            { value: tradesDistribution["Structural Design"] || 0, name: "Structural", color: "#FFA060" },
            { value: tradesDistribution["Fire Sprinkler"] || 0, name: "FP", color: "#E85F5F" },
        ];

        const option = {
            tooltip: {
                trigger: "item",
                backgroundColor: "#fff",
                borderColor: "#ddd",
                borderWidth: 0.5,
                padding: 1,
                textStyle: { color: "#333", fontSize: 14 },
                formatter: (params: any) => `
      <div style="display:flex;align-items:center;gap:6px;padding:5px;">
        <span style="width:10px;height:10px;background:${params.color};border-radius:50%;display:inline-block;"></span>
        <span style="font-weight:500;">${params.name}: ${params.percent}%</span>
      </div>
    `,
            },
            series: [
                {
                    name: "Approved",
                    type: "pie",
                    radius: ["0%", "95%"],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: "inside",
                        formatter: "",
                        fontSize: "10px",
                        fontWeight: 500,
                        color: "#fff",
                        distanceToLabelLine: 4,
                        distance: 12,
                    },
                    itemStyle: {
                        borderColor: "#fff",
                        borderWidth: 2,
                        borderRadius: 0,
                        shadowBlur: 4,
                        shadowColor: "rgba(0,0,0,0.08)",
                    },
                    data: chartData.map((x) => ({
                        value: x.value,
                        name: x.name,
                        itemStyle: { color: x.color },
                    })),
                },
            ],
        };

        chart.setOption(option);

        // Responsive
        const handleResize = () => chart.resize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            chart.dispose();
        };
    }, [tradesDistribution]);
    if ((flag === "all-data" ||
        flag === "dashboard-data" ||
        flag === "dashboard-time-data" ||
        flag === "dashboard-project-type-data" ||
        flag !== "dashboard-trades-type-worker-manager") &&
        (loading || tradesDistribution === null || tradesDistribution === undefined)) {
        return <Box
            sx={{
                bg: bgGeographic,
                p: "1rem",
                borderRadius: "24px",
                boxShadow: "0px 0px 40px 0px rgba(209, 173, 138, 0.12)",
                height: ["490px"]
            }}
        >
            <Text sx={{ fontSize: "16px", fontWeight: 700, mb: "16px", color: titleHeader }}>
                Trades Distribution
            </Text>
            <TradesDistributionSkelton />
        </Box>

    }
    return <Box>
        <Box
            sx={{
                bg: bgGeographic,
                p: "1rem",
                borderRadius: "24px",
                boxShadow: "0px 0px 40px 0px rgba(209, 173, 138, 0.12)",
                height: ["483px"]
            }}
        >
            <Text as={"h6"} sx={{ fontSize: ["10px", "12px", "16px", "18px"], fontWeight: 700, mb: "18px", color: titleHeader }}>
                Trades Distribution
            </Text>
            <Box sx={{
                bg: bgDashboard,
                p: 20,
                borderRadius: "24px",
                boxShadow: "0px 0px 40px 0px rgba(209, 173, 138, 0.12)",
                height: ["415px"]
            }}>
                <Text sx={{ fontSize: "16px", fontWeight: 600, mb: "16px", color: colorMode === 'light' ? '#453521' : '#f8f9fab5' }}>
                    Trades
                </Text>

                {/* Chart */}
                <div ref={chartRef} style={{ width: "100%", height: "225px", marginTop: "10px" }} />

                {/* Legend */}
                <Box sx={{ marginTop: "30px", width: "100%" }}>
                    <Grid columns={[2]} gap={"8px"}>
                        <LegendPill label="Mechanical" value={tradesDistribution["Mechanical (Standard)"]} color="#16A34A" />
                        <LegendPill label="Electrical" value={tradesDistribution["Electrical (Standard)"]} color="#CA8A04" />
                        <LegendPill label="Plumbing" value={tradesDistribution["Plumbing (Standard)"]} color="#2563EB" />
                        <LegendPill label="Structural" value={tradesDistribution["Structural Design"]} color="#FFA060" />
                        <LegendPill label="FP" value={tradesDistribution["Fire Sprinkler"]} color="#E85F5F" />
                    </Grid>
                </Box>
            </Box>
        </Box>
    </Box>
};

export default React.memo(TradesDistribution)